/**
 * Логгер для frontend приложения
 * Заменяет console.log для production кода
 */

const logger = {
  info: (message, ...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[INFO] ${message}`, ...args);
    }
  },
  
  debug: (message, ...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  },
  
  warn: (message, ...args) => {
    console.warn(`[WARN] ${message}`, ...args);
  },
  
  error: (message, ...args) => {
    // Улучшенная обработка ошибок для более информативного логирования
    const processedArgs = args.map(arg => {
      if (arg === undefined) {
        return 'undefined';
      }
      if (arg === null) {
        return 'null';
      }
      if (typeof arg === 'object') {
        try {
          return JSON.stringify(arg, null, 2);
        } catch (e) {
          return String(arg);
        }
      }
      return arg;
    });
    console.error(`[ERROR] ${message}`, ...processedArgs);
  }
};

export default logger;

